import { TableCell } from '@tiptap/extension-table';
import {
  borderEdgeStyleAttributes,
  borderEdgeWeightAttributes,
  offsetCellAttribute,
} from '../nodes/table/borderAttributes';
import { alignAttribute, textRotationAttribute, verticalAlignAttribute } from '../nodes/table/cellAttributes';

const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-background-color'),
        renderHTML: (attributes) => {
          return {
            'data-background-color': attributes.backgroundColor,
            style: attributes.backgroundColor ? `background-color: ${attributes.backgroundColor}` : undefined,
          };
        },
      },
      ...alignAttribute(),
      ...textRotationAttribute(),
      ...verticalAlignAttribute(),
      ...offsetCellAttribute(),
      ...borderEdgeStyleAttributes(),
      ...borderEdgeWeightAttributes(),
    };
  },
});

export default CustomTableCell;
